<p-table [value]="[1, 2, 3, 4, 5]" [tableStyle]="{ 'min-width': '50rem' }">
  @if (header.length > 0) {
  <ng-template pTemplate="header">
    <tr>
      @for (item of header; track $index) {
      <th>{{ item }}</th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item>
    <tr>
      @for (item of header; track $index) {
      <td><p-skeleton /></td>
      }
    </tr>
  </ng-template>
  } @else {
  <ng-template pTemplate="body" let-item>
    <tr>
      <td><p-skeleton /></td>
    </tr>
  </ng-template>
  }
</p-table>
